var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content-text"},[_c('HTMLContent',{attrs:{"content":_vm.content,"is-small":_vm.small}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }